import { createLazyFileRoute } from "@tanstack/react-router";

import { TubesPage } from "@/features/admin/routes/Tubes";

export const Route = createLazyFileRoute("/_auth/admin/tubes/")({
  component: TubesPage,
});
